<script lang="ts">
	import { storyblokEditable } from '@storyblok/svelte';
	import { richTextToHTML } from '@app/utils/cms';

	export let props;
</script>

{#if props}
	<div use:storyblokEditable={props}>
		{@html richTextToHTML(props.text)}
	</div>
{/if}
